
import React, { useState } from 'react';
import {
    AddContainer, Component4, Texts, InputTextComponent,
    PrescriptionViewBox, PresText, PresTitle, EditButton, SaveButton, LabelWithTooltip
} from './Style';
import { Formik, Form } from 'formik';
import {
    Box, Dialog, DialogTitle, DialogContent, DialogActions, Button
} from '@mui/material';
import { ReactComponent as Edit } from '../../../../../assets/images/edit-2.svg';
import { ReactComponent as Add } from '../../../../../assets/images/add-square.svg';
import { ReactComponent as Close } from '../../../../../assets/images/close-circle.svg';
import theme from 'src/config/theme';
import useResponsive from 'src/components/hooks/useResponsive';

const Facilities = ({ innerRef, data, setClinicProfileData }) => {
    const { isMobile, isTablet } = useResponsive();
    const Width = isMobile || isTablet ? '18px' : '20px';
    const Height = isMobile || isTablet ? '18px' : '20px';
    const [selectedFacility, setSelectedFacility] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [localFacilities, setLocalFacilities] = useState(data || []);

    const initialValues = {
        name: selectedFacility?.name || '',
        value: selectedFacility?.value || '',
    };

    const handleEdit = (facility) => {
        setSelectedFacility(facility);
        setOpenDialog(true);
    };

    const handleDelete = (facilityToDelete) => {
        const updatedFacilities = localFacilities.filter(
            f => !(f.name === facilityToDelete.name && f.value === facilityToDelete.value)
        );
        setLocalFacilities(updatedFacilities);
        setClinicProfileData(prev => ({
            ...prev,
            facilities: updatedFacilities,
        }));
    };
    const handleAdd = () => {
        setSelectedFacility(null);
        setOpenDialog(true);
    };

    const handleSubmit = (values, { resetForm }) => {
        if (!values.name.trim() || !values.value.trim()) return;

        setLocalFacilities(prev => {
            const isEditing = !!selectedFacility;
            let updated;

            if (isEditing) {
                updated = prev.map(f =>
                    f.name === selectedFacility.name && f.value === selectedFacility.value
                        ? { name: values.name, value: values.value }
                        : f
                );
            } else {
                const duplicate = prev.find(
                    f => f.name.trim().toLowerCase() === values.name.trim().toLowerCase() &&
                        f.value.trim().toLowerCase() === values.value.trim().toLowerCase()
                );
                if (duplicate) return prev;

                updated = [...prev, { name: values.name, value: values.value }];
            }

            setClinicProfileData(prevData => ({
                ...prevData,
                facilities: updated,
            }));

            return updated;
        });

        setSelectedFacility(null);
        setOpenDialog(false);
        resetForm();
    };


    return (
        <>
            <AddContainer>
                {localFacilities.map((facility, index) => (
                    <PrescriptionViewBox key={index}>
                        <Box>
                            <PresTitle>{facility.name}</PresTitle>
                            <PresText>{facility.value}</PresText>
                        </Box>
                        <Box sx={{ display: 'flex', gap: '8px' }}>
                            <EditButton onClick={() => handleEdit(facility)}>
                                <Edit width={Width} />
                            </EditButton>
                            <EditButton onClick={() => handleDelete(facility)}>
                                <Close width={Width} />
                            </EditButton>
                        </Box>
                    </PrescriptionViewBox>
                ))}

                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <SaveButton
                        variant="outlined"
                        startIcon={<Add width={Width} height={Height} sx={{ color: theme.palette.primary.main }} />}
                        onClick={handleAdd}
                    >
                        Add
                    </SaveButton>
                </Box>
            </AddContainer>

            <Dialog
                open={openDialog}
                onClose={() => {
                    setOpenDialog(false);
                    setSelectedFacility(null);
                }}
                maxWidth="md"
            >
                <DialogTitle>{selectedFacility ? 'Edit Facility' : 'Add New Facility'}</DialogTitle>
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    innerRef={innerRef}
                >
                    {({ values, handleChange }) => (
                        <Form>
                            <DialogContent>
                                <AddContainer>
                                    <Component4>
                                        <Texts>
                                            <LabelWithTooltip
                                                label="Facility Name"
                                                tooltip="Enter a name for the facility you are offering."
                                            />
                                        </Texts>
                                        <InputTextComponent
                                            name="name"
                                            placeholder="Enter Name"
                                            variant="outlined"
                                            value={values.name}
                                            onChange={handleChange}
                                        />
                                    </Component4>
                                    <Component4>
                                        <Texts>
                                            <LabelWithTooltip
                                                label="Facility Value"
                                                tooltip="Specify the value or capacity of the facility (e.g., 5 beds, 24x7 available)."
                                            />
                                        </Texts>
                                        <InputTextComponent
                                            name="value"
                                            placeholder="Enter Value"
                                            variant="outlined"
                                            value={values.value}
                                            onChange={handleChange}
                                        />
                                    </Component4>
                                </AddContainer>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                                <Button type="submit" variant="contained">
                                    {selectedFacility ? 'Update' : 'Save'}
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    );
};

export default React.memo(Facilities);
















